import React, { useState } from "react";
import axios from "axios";
import './App.css';
function App() {
    const [image, setImage] = useState(null);
    const [carInfo, setCarInfo] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle image selection
    const handleImageChange = (event) => {
        setImage(event.target.files[0]);
    };

    // Send image to backend
    const analyzeImage = async () => {
        if (!image) {
            alert("Please upload an image first.");
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("carImage", image);

        try {
            const response = await axios.post("https://api.car.hasthiya.com/analyze", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            setCarInfo(response.data.result);
        } catch (error) {
            console.error("Error analyzing image:", error);
            setCarInfo("Failed to analyze image.");
        }

        setLoading(false);
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <h1>🚗 Car Image Analyzer</h1>
            <input type="file" accept="image/*" onChange={handleImageChange} />
            <br /><br />
            <button onClick={analyzeImage} disabled={loading}>
                {loading ? "Analyzing..." : "Analyze Car"}
            </button>
            <br /><br />
            {image && <img src={URL.createObjectURL(image)} alt="Uploaded" width="300" />}
            <br /><br />
            {carInfo && <div className="result-card"><h3>🔍 Analysis Result:</h3><p>{carInfo}</p></div>}
        </div>
    );
}

export default App;
